import createStyles from "@mui/styles/createStyles";
export const useStyles = (theme) => createStyles({});
